import type { JSX } from "react";

type LogoProps = {
  /** "sm" (default, nav-scale) or "lg" (footer/hero-scale) */
  size?: "sm" | "lg";
  className?: string;
};

/**
 * Oak/deciduous tree mark + "ecocloud" wordmark.
 *
 * The mark is the "Tree Deciduous" glyph from Microsoft's Fluent System
 * Icons (MIT licensed, already an installed dependency via
 * @fluentui/react-icons — this is just its path data inlined so the logo
 * has zero extra runtime cost). Single-color, currentColor-driven SVG so it
 * inherits whatever text color the surrounding `.lp-logo` / `.lp-forest`
 * context applies. Renders at both the nav (sm) and footer/hero (lg) scale
 * via the existing `.lp-logo` / `.lp-logo--xl` classes so no other markup
 * needs to change.
 */
export function Logo({ size = "sm", className }: LogoProps): JSX.Element {
  const classes = ["lp-logo", size === "lg" ? "lp-logo--xl" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes}>
      <svg
        className="lp-logo-mark"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M8 4.82a4.25 4.25 0 0 1 8 0 4.25 4.25 0 0 1 3.37 5.24A4.25 4.25 0 0 1 17.5 18h-3v2.25c0 .97-.78 1.75-1.75 1.75h-1.5c-.97 0-1.75-.78-1.75-1.75V18h-3c-.06 0-.12 0-.18-.02a4.25 4.25 0 0 1-1.69-7.92A4.26 4.26 0 0 1 8 4.82ZM11 18v2.25c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25V18h-2Z" />
      </svg>
      <span className="lp-logo-word">
        eco<b>cloud</b>
      </span>
    </span>
  );
}
